"use strict";

exports.__esModule = true;
exports.default = exports.LayoutContent = exports.Layout = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _Provider = _interopRequireDefault(require("../../providers/Locale/Provider"));

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _locale = require("../../utils/locale");

var _Locale = require("../../providers/Locale");

var _reactRouterDom = require("react-router-dom");

var _Provider2 = _interopRequireDefault(require("../../providers/Update/Provider"));

var _Provider3 = _interopRequireDefault(require("../../providers/Auth/Provider"));

var _Provider4 = _interopRequireDefault(require("../../providers/AddToHomeScreen/Provider"));

var _Provider5 = _interopRequireDefault(require("../../providers/Online/Provider"));

var _Provider6 = _interopRequireDefault(require("../../providers/SimpleValues/Provider"));

var _Config = require("../../providers/Config");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var LayoutContent = function LayoutContent(_ref) {
  var _ref$appConfig = _ref.appConfig,
      appConfig = _ref$appConfig === void 0 ? {} : _ref$appConfig;

  var _useState = (0, _react.useState)([]),
      messages = _useState[0],
      setMessages = _useState[1];

  var _ref2 = appConfig || {},
      components = _ref2.components,
      _ref2$routes = _ref2.routes,
      routes = _ref2$routes === void 0 ? [] : _ref2$routes,
      containers = _ref2.containers,
      confLocale = _ref2.locale,
      getDefaultRoutes = _ref2.getDefaultRoutes,
      auth = _ref2.auth,
      update = _ref2.update;

  var _ref3 = auth || {},
      persistKey = _ref3.persistKey;

  var _ref4 = update || {},
      _ref4$checkInterval = _ref4.checkInterval,
      checkInterval = _ref4$checkInterval === void 0 ? 5000 : _ref4$checkInterval;

  var _ref5 = components || {},
      Menu = _ref5.Menu,
      _ref5$Loading = _ref5.Loading,
      Loading = _ref5$Loading === void 0 ? function () {
    return /*#__PURE__*/_react.default.createElement("div", null, "Loading...");
  } : _ref5$Loading;

  var _ref6 = confLocale || {},
      locales = _ref6.locales,
      onError = _ref6.onError;

  var _ref7 = containers || {},
      _ref7$LayoutContainer = _ref7.LayoutContainer,
      LayoutContainer = _ref7$LayoutContainer === void 0 ? _react.default.Fragment : _ref7$LayoutContainer;

  var defaultRoutes = getDefaultRoutes ? getDefaultRoutes(appConfig) : [];

  var _useLocale = (0, _Locale.useLocale)(),
      _useLocale$locale = _useLocale.locale,
      locale = _useLocale$locale === void 0 ? {} : _useLocale$locale;

  (0, _react.useEffect)(function () {
    var loadPolyfills = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var i, l;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(locale.locales && locale.locales.length > 0)) {
                  _context.next = 11;
                  break;
                }

                i = 0;

              case 2:
                if (!(i < locales.length)) {
                  _context.next = 11;
                  break;
                }

                l = locales[i];

                if (!(l.locale === locale)) {
                  _context.next = 8;
                  break;
                }

                if (!l.loadData) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return l.loadData;

              case 8:
                i++;
                _context.next = 2;
                break;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function loadPolyfills() {
        return _ref8.apply(this, arguments);
      };
    }();

    loadPolyfills();
  }, [locale, locales]);
  (0, _react.useEffect)(function () {
    var loadMessages = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var messages;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _locale.getLocaleMessages)(locale, locales);

              case 2:
                messages = _context2.sent;
                setMessages(messages);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function loadMessages() {
        return _ref9.apply(this, arguments);
      };
    }();

    loadMessages();
  }, [locale, locales]);
  return /*#__PURE__*/_react.default.createElement(_Provider3.default, {
    persistKey: persistKey
  }, /*#__PURE__*/_react.default.createElement(_Provider6.default, null, /*#__PURE__*/_react.default.createElement(_Provider4.default, null, /*#__PURE__*/_react.default.createElement(_Provider2.default, {
    checkInterval: checkInterval
  }, /*#__PURE__*/_react.default.createElement(_Provider5.default, null, /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, {
    locale: locale,
    key: locale,
    messages: messages,
    onError: onError
  }, /*#__PURE__*/_react.default.createElement(LayoutContainer, null, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(Loading, null)
  }, Menu && /*#__PURE__*/_react.default.createElement(Menu, null)), /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(Loading, null)
  }, (0, _reactRouterDom.useRoutes)([].concat(routes, defaultRoutes))))))))));
};

exports.LayoutContent = LayoutContent;

var Layout = function Layout() {
  var _useConfig = (0, _Config.useConfig)(),
      appConfig = _useConfig.appConfig;

  var _ref10 = appConfig || {},
      locale = _ref10.locale;

  var _ref11 = locale || {},
      defaultLocale = _ref11.defaultLocale,
      persistKey = _ref11.persistKey;

  return /*#__PURE__*/_react.default.createElement(_Provider.default, {
    defaultLocale: defaultLocale,
    persistKey: persistKey
  }, /*#__PURE__*/_react.default.createElement(LayoutContent, {
    appConfig: appConfig
  }));
};

exports.Layout = Layout;
var _default = Layout;
exports.default = _default;